import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import React from 'react';
import { TextButton } from 'wix-ui-tpa';
import { Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { connect } from '../../../../common/components/runtime-context';
import { IActionCreators } from '../../../../types/internal-types';
import { RootState } from '../../state';
import { getMaxUserActions } from '../../selectors';
import { classes } from './SubscriptionsListItemBass.st.css';

export const SKIP_SUBSCRIPTION_CTA_DATA_HOOKS = {
  button: 'subscription-skip-button',
  tooltip: 'subscription-skip-limit-tooltip',
};

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

interface Props {
  subscription: Subscription;
  disabled?: boolean;
}
const SkipSubscriptionCta = ({ subscription, disabled, maxUserActions, actionCreators }: Props & RuntimeProps) => {
  const { t } = useTranslation();
  const button = (
    <TextButton
      data-hook={SKIP_SUBSCRIPTION_CTA_DATA_HOOKS.button}
      className={classes.cta}
      disabled={disabled}
      onClick={() => {
        actionCreators.openSkipConfirmModal(subscription.id!);
      }}
    >
      {t('app.subscription.overviewModal.skipOrdersCta')}
    </TextButton>
  );

  if (!disabled) {
    return button;
  }

  return (
    <Tooltip
      dataHook={SKIP_SUBSCRIPTION_CTA_DATA_HOOKS.tooltip}
      content={t('app.subscription-status.popover.tooltip.skipLimitMessage', { count: maxUserActions })}
      placement="top"
      inline={true}
      textAlign="center"
    >
      <span>{button}</span>
    </Tooltip>
  );
};

const mapRuntimeToProps = (state: RootState, { subscription }: Props, actionCreators: IActionCreators) => {
  return {
    actionCreators,
    maxUserActions: getMaxUserActions(state, subscription),
  };
};

export default connect(mapRuntimeToProps)(SkipSubscriptionCta);
